// extracted by mini-css-extract-plugin
export default {"radio":"DiningOption-module__radio___jNqfc"};